<template>
  <div class="booking-choose-customer">
    <div class="field-title">请选择参与活动的客人</div>
    <div v-for="item in customerList" :key="item.bookingId">
      <p class="customer-info">
        <span>船票订单号：{{item.bookingId}}</span>
        <span>房间号：{{item.stateroomNumber}}</span>
      </p>
      <div class="customer-list">
        <ul>
          <li v-for="customer in item.bookingGuests" :key="customer.id" :class="['customer-item', {'child-menu-active': handleShowChildMenu(customer), disabled: !customer.canSelect}]" >
            <div @click="customerChange(customer)" class="info-wrapper" :class="{active: customerChoosed.indexOf(customer.id) >= 0}">
              <div class="name-box">
                <div class="check-box"></div>
                <p class="name el">{{customer.pinYinLastName}} {{customer.pinYinFirstName}}</p>
              </div>
              <p class="info">出生时间：{{dayjs(customer.dateOfBirth).format('YYYY-MM-DD')}}</p>
            </div>
            <transition name="slide">
            <div v-if="handleShowChildMenu(customer)" class="menu-wrapper">
              <div class="menu-list">
                <div class="menu-item"  v-for="(product) in customer.products" :key="product.id" @click="menuChange(product,customer.id)">
                  <div class="menu-check-box" :class="{active:customer.selectedProductId===product.id}"></div>
                  <span>{{ product.isMainProduct?'标准菜单：':"儿童菜单：" }}</span>
                  <span class="price">${{priceDiscountedFormat(product)}}</span>
                </div>
              </div>
              <div class="menu-tip">
                <div>*儿童套餐菜单菜品与标准菜单菜品有所差异，以游轮上实际运营情况为准。</div>
                <div>如需品尝完整菜单，请选择标准菜单。</div>
              </div>

            </div>
            </transition>
          </li>
        </ul>
      </div>
    </div>
    <a v-if="customerList.length < 8" v-show="!addShow" href="javascript:;" class="btn-add" @click="addShow = true">新增舱房<van-icon class="icon" name="plus" /></a>
    <div class="add-form" v-show="addShow">
      <div class="box-title">
        <span>新增舱房</span>
        <img class="icon" src="../../assets/icons/icon_reduce.png" alt="" @click="addShow = false" />
      </div>
      <div class="form-tip">
        添加船票信息后，您可查看该船票内乘客信息并为其预订行前订产品
      </div>
      <div class="form-content">
        <div class="form-item" @click="screenTypeShow = true">
          <span>{{screenTypes[screenType].name}}</span>
          <van-icon class="icon-arrow" name="arrow-down" />
        </div>
        <div class="form-item" v-if="!screenType">
          <input class="ipt" type="text" v-model="bookingId" placeholder="请填写船票订单号">
        </div>
        <template v-else>
          <div class="form-item">
            <input class="ipt" type="text" v-model="stateroomNumber" placeholder="请填写舱房号">
          </div>
        </template>
        
        <div class="form-item">
          <input class="ipt" type="text" v-model="lastName" placeholder="请填写订票人姓氏 例“ZHANG”" @input="lastNameInput">
        </div>
        <div class="form-item" @click="birthdayPickerShow = true">
            <input class="ipt" type="text" v-model="dateOfBirth" placeholder="请填写上述乘客对应的出生日期">
            <van-icon class="icon-arrow" name="arrow-down" />
          </div>
        <div class="form-item disabled">所乘游轮：{{bindTicket.shipName}}</div>
        <div class="form-item disabled">出航日期：{{sailDate}}</div>
        <van-button class="form-item btn-submit" block :loading="submitting" loading-text="加载中..." @click="handleSubmit">确认添加</van-button>
      </div>
    </div>
    <!-- 查询类型 -->
    <custom-picker title="选择查询方式" :columns="screenTypes" :visible.sync="screenTypeShow" @change="screenType = arguments[0]" />
    <!-- 生日 -->
    <base-picker type="date" :visible.sync="birthdayPickerShow" :value.sync="dateOfBirth" :min-date="minDate" :max-date="maxDate"/>
  </div>
</template>

<script>
import BasePicker from '@/components/BasePicker'
import CustomPicker from '@/components/CustomPicker'
import api from '@/api'
import {hideLoading, showAlert, showLoading, showToast} from '@/utils/tools'
import dayjs from 'dayjs'
import pick from 'lodash/pick'
import { mapState } from 'vuex'

const screenTypes = [
  {
    name: '订单号',
    value: 0
  }, {
    name: '舱房号',
    value: 1
  }
]
export default {
  name: 'BookingChooseCustomer',

  components: {
    BasePicker,
    CustomPicker
  },

  props: {
    goodsInfo: Object,
    isFullCabinBooking: {
      type: Boolean,
      default: false
    },
    canBookingGuests: Array,
    isShoppingCart: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      dayjs,
      screenTypes,
      addShow: false,
      customerList: [],
      customerChoosed: [],
      screenTypeShow: false,
      screenType: 0,
      birthdayPickerShow: false,
      minDate: dayjs().subtract(100, 'year').toDate(),
      maxDate: dayjs().toDate(),
      dateOfBirth: '',
      bookingId: '',
      stateroomNumber: '',
      lastName: '',
      submitting: false,
      addedBook: 0
    }
  },

  computed: {
    ...mapState(['bindTicket']),
    productId () {
      return this.goodsInfo.id
    },
    sailDate () {
      return dayjs(this.bindTicket.sailDate).format('YYYY-MM-DD')
    },
    isRespecting () {
      // return this.goodsInfo.name.indexOf('皇家尊享服务') >= 0
      return this.goodsInfo.name.indexOf('皇家尊享服务') >= 0
    },
    childMenuId() {
      let menuId = null
      this.canBookingGuests.forEach(guest=>{
       if (guest.products.length > 1) {
          guest.products.forEach(product=>{
            if (!product.isMainProduct) {
              menuId = product.id
            }
          })
       }

     }) 
     return menuId
    },
    // hideChildMenu() {
    //   // 购物车页面儿童菜单产品不展示选择
    //   return this.isShoppingCart && this.childMenuId===this.goodsInfo.id
    // },

  },
  watch: {
    goodsInfo (val) {
      this.initData(val)
    },
    isFullCabinBooking () {
      this.initData(this.goodsInfo)
    },
    canBookingGuests() {
      this.initData(this.goodsInfo)
    }
  },
  mounted () {
  },
  methods: {
    initData(val) {
      this.customerList = [];
      this.customerChoosed = [];
      const { initBookingGuests, initBookingGuestsChoosed,id } = val
      if (initBookingGuests && initBookingGuestsChoosed) {
        this.customerList=this.formatCustomerList(initBookingGuests,id)
        this.customerChoosed = initBookingGuestsChoosed
        if (this.isFullCabinBooking) {
          this.customerList && this.customerList.forEach((row) => {
            row.bookingGuests = row.bookingGuests.map(x => ({...x, canSelect: this.customerChoosed.includes(x.id)}))
          })
        }
      } else {
        const { bookingGuests, ...others } = this.$store.state.bindTicket
        this.customerList.push({
          ...others,
          bookingGuests: bookingGuests?.map(x => ({ ...x, canSelect: true,products: this.getProducts(x.id),selectedProductId:null }))
        })
        if (this.isFullCabinBooking) {
          this.customerChoosed = this.canBookingGuests.map(x => x.id)
          this.customerList && this.customerList.forEach((row)=> {
            row.bookingGuests = row.bookingGuests.map(x => ({ ...x, canSelect: this.customerChoosed.includes(x.id) }))
          })
          this.$emit('customerChange', this.customerChoosed.length)
        }
      }
    },
    getProducts(guestId, productId) {
      const guests = this.canBookingGuests || [];

      // 查找指定guest
      const guest = guests.find(item => item.id === guestId);

      // 编辑时直接返回完整产品列表（如果产品数>1）
      if (guest?.products?.length > 1) {
        return guest.products;
      }

      // 根据productId查找单一产品
      if (productId) {
        for (const item of guests) {
          const product = item.products?.find(p => p.id === +productId);
          if (product) {
            return [product];
          }
        }
      }

      // 默认返回guest的产品列表或空数组
      return guest?.products || [];
    },
    async handleSubmit () {
      if (this.submitting) return
      if (!this.screenType) {
        if (!this.bookingId.length) return showToast('请填写船票订单号')
        let selectBookingNum = 0;
        this.customerList && this.customerList.forEach(item => {
          if(item.bookingId === this.bookingId) {
            selectBookingNum++;
          }
        })
        if(selectBookingNum>0) return showToast('该船票订单已添加')
      } else {
        
        if (!this.stateroomNumber.length) return showToast('请填写舱房号')
      }
      if (!this.dateOfBirth) return showToast('请填写上述乘客对应的出生日期')
      if (!this.lastName.length) return showToast('请填写订票人姓氏')
      this.submitting = true
      const { errCode, errMsg, data } = await api.getCanSelectGuestsByProduct({
        ...pick(this.$data, ['bookingId', 'stateroomNumber', 'dateOfBirth', 'lastName']),
        shipCode: this.bindTicket.shipCode,
        sailDate: this.sailDate,
        productId: this.productId
      })
      this.submitting = false
      if (errCode === 0) {
        let selectBookingNum = 0;
        this.customerList && this.customerList.forEach(item => {
          if(item.bookingId === data.bookingId) {
            selectBookingNum++;
          }
        })
        if(selectBookingNum>0) {
          return showToast('该船票订单已添加')
        }
        const { bookingGuests, ...others } = data
        const bookingGuestsFormat = bookingGuests.guestPersons.map(x => ({ ...x, pinYinFirstName: x.pyFirstName, pinYinLastName: x.pyLastName, dateOfBirth: x.birthDay,selectedProductId:null }))
        this.customerList.push({
          ...others,
          bookingGuests: bookingGuestsFormat
        })
        // console.log('bookingGuestsFormat',bookingGuestsFormat)
        // this.customerList=this.formatCustomerList(this.customerList)
        await this.getCanBookingGuests(this.productId, this.sailDate, data.bookingId);
        this.$emit('customerSubmit', data.bookingId)
        this.addShow = false
        this.dateOfBirth = ''
        this.bookingId = ''
        this.stateroomNumber = ''
        this.lastName = ''
        this.addedBook ++
      } else {
        showAlert(errMsg || '添加失败，请稍后重试')
      }
    },
    lastNameInput () {
      if (/^[a-zA-Z]+$/.test(this.lastName.trim())) this.lastName = this.lastName.toUpperCase()
    },
    customerChange ({ id, canSelect }) {
      if (!canSelect) return
      if (this.isFullCabinBooking) return showAlert('该产品仅限全房客人预订')
      const currentIndex = this.customerChoosed.indexOf(id)
      if (currentIndex >= 0) {
        this.customerChoosed.splice(currentIndex, 1)
      } else {
        this.customerChoosed.push(id)
        this.customerList?.forEach(item => {
          item.bookingGuests.forEach(x => {
            // 只有标准菜单,直接回填selectedProductId
            // 儿童菜单不默认选中菜单，需要选择 
            if (x.id === id) {
              if (x.products.length === 1) {
                x.selectedProductId = x.products[0].id
              } else if (x.products.length > 1) {
                x.selectedProductId = null
              }

            }
          })
        })
      }
      this.$emit('customerChange', this.customerChoosed.length)
    },
    async getCanBookingGuests (productId, sailDate, bookingId) {
      console.log(productId, sailDate, bookingId)
      showLoading()
      const { errCode, errMsg, data } = await api.getCanBookingGuests({
        productId: productId,
        sailDate: sailDate,
        bookingId: bookingId
      })
      hideLoading()
      if (errCode === 0) {
        if (data.isFullCabinBooking) {
          let canBookingGuests = data.bookingGuests.map(x => x.id);
          this.customerChoosed = this.customerChoosed.concat(canBookingGuests)
          this.$emit('customerChange', this.customerChoosed.length)
        }
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
    },
    priceDiscountedFormat (current) {
      const calcResult = current.priceDiscounted - current.priceDiscountedServiceCharge
      return calcResult % 1 === 0 ? calcResult : calcResult.toFixed(2)
    },
    menuChange(product, customerId) { 
      const { id } = product
      this.customerList?.forEach(item => {
        item.bookingGuests.forEach(guest => {
          if (guest.id === customerId) {
               guest.selectedProductId=id
            }
          })
        })
    },
    formatCustomerList(customerList,selectedProductId) { 
       return customerList?.map(row => {
          row.bookingGuests = row.bookingGuests?.map(x => ({
            ...x,
            products: this.getProducts(x.id,selectedProductId),
            selectedProductId:selectedProductId|| x.selectedProductId||null
          }))
          return row
        })
    },
    handleShowChildMenu(customer) {
      const   hasChildMenu=customer?.products?.length === 2          
      return  hasChildMenu && this.customerChoosed.indexOf(customer.id) >= 0     
    },
  }
}
</script>

<style lang="less" scoped>
.booking-choose-customer {
  padding-bottom: 16px;
}
.customer-info {
  font-size: 18px;
  color: #999;
  line-height: 36px;
  span {
    margin-right: 12px;
  }
}
.customer-list {
  padding: 20px 0;
  .customer-item {
    margin-bottom: 10px;
    border-radius: 6px;
    border: 1Px solid #eaeaea;
    font-size: 18px;
    color: #999;
    &.child-menu-active{
     border: 1Px solid #306EB7;
    }
    .info-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 46px;
        padding: 0 22px 0 11px;
        border-radius: 6px;
    
        &.active {
          background-color: @second-color;
    
          .name-box .check-box {
            background: #e1af00 url('../../assets/icons/icon_check.png') center center no-repeat;
            background-size: 16px auto;
          }
        }
      }
 .menu-wrapper {
      padding: 22px 86px 22px 63px;
      .menu-list {
        display: flex;
        justify-content: space-between;

        .menu-item {
          display: flex;
          align-items: center;
          font-size: 19px;
          color: #2C2C2E;

          .price {
            font-weight: 500;
            color: #FFC400;
          }

          .menu-check-box {
            width: 19px;
            height: 19px;
            margin-right: 8px;
            border-radius: 4px;
            background: #E5E5E7;

            &.active {
              background: #e1af00 url('../../assets/icons/icon_check.png') center 6px no-repeat;
              background-size: 11px auto;
            }

          }
        }
      }

      .menu-tip {
        margin-top: 25px;
        font-size: 13px;
        color: #2C2C2E;
      }
    }                              
    &.disabled{
      opacity: .6;
    }
    .name-box {
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #333;
      .check-box {
        flex: none;
        width: 28px;
        height: 28px;
        margin-right: 22px;
        border-radius: 5px;
        background-color: #e5e5e5;
      }
    }
  }
}
.btn-add {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 200px;
  height: 48px;
  box-sizing: border-box;
  padding: 0 12px 0 30px;
  border-radius: 6px;
  font-size: 24px;
  color: #1174b8;
  background-color: #e8f4fe;
  .icon {
    font-size: 24px;
    color: #1174b8;
  }
}
.add-form {
  border-radius: 6px;
  overflow: hidden;
  background-color: #e8ecef;
  .box-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 52px;
    padding: 0 30px;
    font-size: 24px;
    color: #fff;
    background-color: #1174b8;
    .icon {
      width: 16px;
    }
  }
  .form-tip{
    padding: 10px 28px;
    font-size: 17px;
    color: #666666;
  }
  .form-content {
    padding: 0 28px 20px;
    .form-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 52px;
      margin-bottom: 15px;
      padding: 0 26px 0 30px;
      border-radius: 6px;
      background-color: #fff;
      font-size: 24px;
      color: #242e65;
      &.disabled {
        color: #333;
        background-color: #d7dde1;
      }
      .icon-arrow {
        font-size: 24px;
      }
      .ipt {
        flex: 1;
        height: 28px;
        padding-left: 0;
        border: none;
        outline: none;
      }
    }
    .btn-submit {
      justify-content: center;
      color: #333;
      line-height: 32px;
      background-color: @second-color;
    }
  }
}
</style>
